import { render, staticRenderFns } from "./WfViolationsForm.vue?vue&type=template&id=28a4bfdc&"
import script from "./WfViolationsForm.vue?vue&type=script&lang=js&"
export * from "./WfViolationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports